import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import de from "./de.json";
import enUS from "./en-US.json";
import esES from "./es-ES.json";
import fr from "./fr.json";
import it from "./it.json";
import sp from "./sp.json";

i18next.use(initReactI18next).init({
  lng: "en", // if you're using a language detector, do not define the lng option
  fallbackLng: "en",
  debug: true,
  resources: {
    en: { translation: enUS },
    fr: { translation: fr },
    it: { translation: it },
    sp: { translation: sp },
    esES: { translation: esES },
    de: { translation: de },
  },
  interpolation: {
    escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
  },
});
